<header class="organizer-qr-code-validation__header container">
  <app-logo
    class="organizer-qr-code-validation__header__logo"
    height="28"
    [name]="logoType.OrganizerDark"
    [alt]="'a11y.fed_landing.logo' | translate"
  ></app-logo>
</header>
<main class="organizer-qr-code-validation__content container">
  <app-section
    [title]="statusTitle"
    class="organizer-qr-code-validation__content__section"
  >
    <div
      *ngIf="isLoading"
      class="organizer-qr-code-validation__loading spinner"
    ></div>
    <div *ngIf="!isLoading" class="organizer-qr-code-validation__container">
      <div class="organizer-qr-code-validation__icon">
        <vtmn-play-icon
          [name]="statusIcon"
          [height]="36"
          [width]="36"
        ></vtmn-play-icon>
      </div>
      <div class="organizer-qr-code-validation__data">
        <div class="organizer-qr-code-validation__data__primary">
          {{ qrCode?.attendee }}
        </div>
        <div
          *ngIf="displayAge"
          class="organizer-qr-code-validation__data__secondary"
        >
          {{ ageTranslation }}
        </div>
        <div class="organizer-qr-code-validation__data__secondary">
          {{ statusDescription }}
        </div>
        <div class="organizer-qr-code-validation__data__secondary">
          {{ 'organizer_qr_code_validation.scan-count' | translate }}
          {{ qrCode?.scanCount }}
        </div>
      </div>
    </div>
  </app-section>
</main>
